<template>
    <b-modal id="modal-cancelamento-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalCancelamentoDetalhe">
       <template v-slot:modal-header="{ close }">
            <h5 v-if="!(loading || error)">Pedido de Cancelamento nº {{ nrPedido }}</h5>
        </template>
        <template v-slot:default="{ hide }">
            <template v-if="loading || error">
                <div v-if="loading" class="text-center"
                    style="
                        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
                        width: 100%;
                        height: 100%;
                        display: block;
                        z-index: 10002;
                        margin: 0;
                    "
                >
                    <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Text Centered"
                    ></b-spinner>
                    <br /><span style="color: #004e86">Processando Aguarde...</span>
                </div>
            </template>
            <template v-else>
                <b-row>
                    <b-col class="col-xl-6 col-12 card-column-left">
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Solicitante</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nome:</b> {{ solicitante.nm_solicitante }}</span>
                                <span><b>Documento:</b> {{ solicitante.documento_solicitante }}</span>
                                <!-- TODO - ADICIONAR CAMPOS ESTADOCIVIL E PROFISSAO NA CHAMADA -->
                                <!-- <span><b>Estado Civil:</b> {{ solicitante.estadoCivil }}</span> -->
                                <!-- <span><b>Profissão:</b> {{ solicitante.profissao }}</span> -->
                                <span><b>Telefone:</b> {{ solicitante.telefone_solicitante }}</span>
                                <span><b>Celular:</b> {{ solicitante.celular_solicitante }}</span>
                                <span><b>E-mail:</b> {{ solicitante.nm_email_solicitante }}</span>
                                <hr />
                                <span><b>Endereço:</b> 
                                    {{ solicitante.endereco_solicitante + ', ' + solicitante.nr_endereco_solicitante + (solicitante.complemento_solicitante ? ' - ' + solicitante.complemento_solicitante : '') +
                                                                    ' - ' + solicitante.bairro_solicitante + ' - ' +
                                                                    solicitante.cidade_solicitante + ' - ' + solicitante.uf_solicitante }}</span>
                            </div>
                        </div>
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Cartório</h3>
                            </div>
                            <div class="modal-card-body">                           
                                <span><b>Nome:</b> {{ cartorio.nome_cartorio }}</span>
                                <span><b>E-mail:</b> {{ cartorio.email_cartorio }}</span>
                                <span><b>CNPJ:</b> {{ cartorio.documento_cartorio }}</span>
                                <span><b>Telefone:</b> {{ cartorio.telefone_cartorio }}</span>
                                <hr>
                                <span><b>Endereço:</b> {{ cartorio.endereco_cartorio + ', ' + cartorio.nr_endereco_cartorio + 
                                                                        ( cartorio.complemento_cartorio ? ' - ' + cartorio.complemento_cartorio : '' ) }}</span>
                                <span><b>Bairro:</b> {{ cartorio.bairro_cartorio }}</span>
                                <span><b>Cidade:</b> {{ cartorio.cidade_cartorio }}</span>
                                <span><b>UF:</b> {{ cartorio.uf_cartorio }}</span>
                                <span><b>CEP:</b> {{ cartorio.cep_cartorio }}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-12 card-column-right">
                        <div class="modal-card pt-2">
                            <div class="modal-card-header">
                                <h3>Dados do Pedido</h3>
                            </div>
                            <div class="modal-card-body">                     
                                <div class="row-body">
                                    <span><b>Nº Pedido:</b> {{ pedido.cd_pedido }}</span>
                                    <span><b>Dt. Pedido:</b> {{ pedido.data_pedido }}</span>
                                    <span><b>Status:</b> {{ pedido.status_pedido }}</span>
                                </div>      
                                <span v-if="pedido.cd_status == 17" ><b>Valor Complementar:</b> {{ pedido.vl_orcamento }}</span>
                                <!-- <span><b>Valor Pedido:</b> {{ pedido.vl_orcamento }}</span> -->
                                <!-- <span><b>Chave Verificação:</b> {{ pedido.nm_chave_verificacao }}</span> -->
                                <!-- TODO - ALERT COM MENSAGENS AO USUARIO (QUAIS MENSAGENS MOSTRAR?) -->
                            </div>
                        </div>
                        <div class="modal-card pb-3 pt-2">
                            <div class="modal-card-header">
                                <h3>Dados da Anuência</h3>
                            </div>
                            <div class="modal-card-body" v-if="cancelamento.cd_anuencia !== null">
                                <span><b>Nº Anuência:</b> {{ cancelamento.cd_anuencia }}</span>
                                <span><b>Dt. Solicitação:</b> {{ cancelamento.data_pedido }}</span>
                                <span><b>Status:</b> {{ cancelamento.status_anuencia }}</span>
                                <span><b>Valor Emol. para Cancelamento:</b> {{ cancelamento.vl_custas_emol}}</span>
                                <span><b>Doc. Devedor:</b> {{ cancelamento.documento_devedor }}</span>
                                <span><b>Nome Devedor:</b> {{ cancelamento.nm_devedor }}</span>
                                <span><b>N° Titulo:</b> {{ cancelamento.nr_titulo }}</span>
                                <span><b>Data Emissão:</b> {{ cancelamento.dt_emissao_titulo }}</span>
                                <span><b>Data Vencimento:</b> {{ cancelamento.dt_venc_titulo }}</span>
                                <span><b>Vlr. Titulo:</b> {{ cancelamento.vl_titulo }}</span>
                                <span><b>Vlr. Protestado:</b> {{ cancelamento.vl_protesto }}</span>
                                <span><b>Protocolo:</b> {{ cancelamento.nr_protocolo_titulo }}</span>
                                <span><b>Data Protocolo:</b> {{ cancelamento.dt_protocolo }}</span>
                                <span><b>Data Protesto:</b> {{ cancelamento.dt_ocorrencia }}</span>
                                <span><!--FILLERSPAN--></span>
                                <span class="mt-4 mb-5"><i>Certidão relativa aos últimos 5 anos.</i></span>
                            </div>
                            <div class="modal-card-body" v-else>
                                <span><b>Nº Anuência:</b> {{ anuencia.cd_anuencia_titulo }}</span>
                                <span><b>Dt. Solicitação:</b> {{ anuencia.dt_cadastro }}</span>
                                <span><b>Status:</b> {{ anuencia.ds_anuencia_status }}</span>
                                <span><b>Valor Emol. para Cancelamento:</b> {{ anuencia.vl_custas }}</span>
                                <span><b>Doc. Devedor:</b> {{ titulo.nm_nr_documento_devedor }}</span>
                                <span><b>Nome Devedor:</b> {{ titulo.nm_devedor }}</span>
                                <span><b>N° Titulo:</b> {{ titulo.nm_nr_titulo }}</span>
                                <span><b>Data Emissão:</b> {{ titulo.dt_emissaof }}</span>
                                <span><b>Data Vencimento:</b> {{ titulo.dt_vencimentof }}</span>
                                <span><b>Vlr. Titulo:</b> {{ titulo.vl_titulo }}</span>
                                <span><b>Vlr. Protestado:</b> {{ titulo.vl_protesto }}</span>
                                <span><b>Protocolo:</b> {{ titulo.nm_nr_protocolo }}</span>
                                <span><b>Data Protocolo:</b> {{ titulo.dt_protocolof }}</span>
                                <span><b>Data Protesto:</b> {{ titulo.dt_ocorrenciaf }}</span>
                                <span><!--FILLERSPAN--></span>
                                <span class="mt-4 mb-5"><i>Certidão relativa aos últimos 5 anos.</i></span>
                            </div>
                        </div>
                        <!-- <div class="modal-card pt-2" v-if="hasHistoricoTed">
                            <div class="modal-card-header">
                                <h3>Histórico da TED</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Pagamento:</b> {{ historicoTed.nr_pagamento }}</span>
                                <span><b>Vlr. Pagamento:</b> {{ historicoTed.vl_ted }}</span>
                                <div class="row-body">
                                    <span><b>Status</b></span>
                                    <span><b>Ocorrência</b></span>
                                    <span><b>Data</b></span>
                                </div>
                                <div class="row-body" v-for="(historico, index) in historicoTed.historicos">
                                    <span> {{ historico.statusTed }}</span>
                                    <span> {{ historico.nm_descricao + ' - ' + historico.ds_erro }}</span>
                                    <span> {{ historico.dt_cadastro}}</span>
                                </div>
                            </div>
                        </div> -->
                        <div class="modal-card pt-2" v-if="hasHistoricoBoleto">
                            <div class="modal-card-header">
                                <h3>Histórico do Recebimento</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Nº Pedido:</b> {{ historicoBoleto.codigoPedido }}</span>
                                <span><b>Vlr. Recebimento:</b> {{ historicoBoleto.valorBoleto }}</span>
                                <span><b>Forma Pgto.:</b> {{ historicoBoleto.formaPagamento }}</span>
                                <span></span>
                                <span class="d-none d-xl-block"><b>Status</b></span>
                                <span class="d-none d-xl-block"><b>Data</b></span>
                                <template v-for="(historico, index) in historicoBoleto.historicos">
                                    <span class="d-block d-xl-none"><b>Status</b> {{ (1+index) + ' - ' + historico.nm_boleto_status }}</span>
                                    <span class="d-none d-xl-block">{{ (1+index) + ' - ' + historico.nm_boleto_status }}</span>
                                    <span class="d-block d-xl-none"><b>Data</b> {{ historico.dt_cadastro }}</span>
                                    <span class="d-none d-xl-block">{{ historico.dt_cadastro }}</span>
                                </template>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-slot:modal-footer="{ ok }">
            <b-button :disabled="loading" size="lg" variant="success" @click="devolveResposta('s')" >Fechar</b-button>
        </template>
    </b-modal>
</template>
<script>

import API from '../../services/api';
export default {
    props:{
        nrPedidoCancelamento : '',
        cancelamentoDados:{},
    },
    methods: {
        getCancelamentoDetalhe(){
            this.loading = true;
            // this.error = false;
            this.token = localStorage.getItem('jwtToken');
            this.carregando = true;
            this.getHistoricoTed();
            this.getHistoricoBoleto();
            this.getDetalhesCancelamento();
            this.loading = false;
            this.carregando = false;
        },
        getHistoricoTed(){
            if(this.cancelamentoDados != undefined  &&  this.cancelamentoDados.cd_ted_arquivo != null ){
                API.get(`certidao/historico/ted/${this.cancelamentoDados.cd_ted_arquivo}?token=${this.token}`).then((res) => {
                    this.modalCancelamentoOk = true;
                    this.historicoTedDados = res.data;
                    if(this.historicoTedDados && this.historicoTedDados !== undefined && Object.keys(this.historicoTedDados).length > 0  && this.historicoTedDados.length > 0){
                        let tedLista = this.historicoTedDados;
                        let historicoTed = {
                            vl_ted: this.currencyFormatter.format(tedLista[0].vl_ted?tedLista[0].vl_ted:''),
                            nr_pagamento: tedLista[0].nr_pagamento,
                            historicos:[],
                        };
                        tedLista.forEach(ted => {
                            historicoTed.historicos.push({
                                cd_ted_arquivo_status: ted.cd_ted_arquivo_status,
                                dt_cadastro: this.formatDataHora(ted.dt_cadastro),
                                nm_descricao: ted.nm_descricao,
                                ds_erro: ted.ds_erro,
                                nm_ted_status: ted.nm_ted_status,
                                statusTed: this.getStatusHistoricoTed(ted.ds_erro, ted.cd_ted_arquivo_status, ted.nm_ted_status)
                            });
                        });     
                        this.hasHistoricoTed = true;
                        this.historicoTed = historicoTed;
                    }
                    else{
                        this.hasHistoricoTed = false;
                        this.historicoTed = {};
                    }
                }).catch((error) => {
                    this.hasHistoricoTed = false;
                    console.log(error);
                });
            }
        },
        getHistoricoBoleto(){
            if(this.cancelamentoDados != undefined  && this.cancelamentoDados.cd_certidao != null){
                API.get(`certidao/historico/boleto/${this.cancelamentoDados.cd_certidao}?token=${this.token}`).then((res) => {
                    this.modalCancelamentoOk = true;
                    this.historicoBoletoDados = res.data;
                    if(this.historicoBoletoDados && this.historicoBoletoDados !== undefined && Object.keys(this.historicoBoletoDados).length > 0  && this.historicoBoletoDados.length > 0){
                        let boletos = this.historicoBoletoDados;
                        let historicoBoleto = {
                            codigoPedido: boletos[0].cd_pedido,
                            valorBoleto: this.currencyFormatter.format(boletos[0].vl_boleto?boletos[0].vl_boleto:''),
                            formaPagamento: this.getFormaPagtoLiquidacao(boletos[0].cd_pedido?boletos[0].cd_pedido:''),
                            historicos:[],
                        };
                        boletos.forEach(boleto => {
                            historicoBoleto.historicos.push({
                                cd_boleto_status: boleto.cd_boleto_status,
                                vl_boleto: this.currencyFormatter.format(boleto.vl_boleto),
                                cd_pedido: boleto.cd_pedido,
                                nm_boleto_status: boleto.nm_boleto_status,
                                cd_boleto: boleto.cd_boleto,
                                cd_api_boleto_config: boleto.cd_api_boleto_config,
                                dt_cadastro: this.formatDataHora(boleto.dt_cadastro),
                            });
                        });                
                        this.hasHistoricoBoleto = true;
                        this.historicoBoleto = historicoBoleto;
                    }
                    else{
                        this.hasHistoricoBoleto = false;
                        this.historicoBoleto = [];
                    }
                }).catch((error) => {
                    this.hasHistoricoBoleto = false;
                    console.log(error);
                });
            }
        },
        getDetalhesCancelamento(){
            if(this.cancelamentoDados != undefined && this.cancelamentoDados.cd_certidao != null){
                API.get(`certidao/detalhe/cancelamento/${this.cancelamentoDados.cd_certidao}?token=${this.token}`).then((res) => {
                    this.modalCancelamentoOk = true;
                    this.detalheCancelamento = res.data;
                }).catch((error) => {
                    console.log(error);
                });
            }
        },
        devolveResposta(resposta) {
            this.loading = true;
            this.cleanModal();
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-cancelamento-detalhe');
        },
        cleanModal(){
            this.nrPedidoCancelamento = null;
            this.cancelamentoDados = {};
            this.historicoTedDados = {};
            this.historicoBoletoDados = [];
            this.hasHistoricoBoleto = false;
            this.hasHistoricoTed = false;
        },
        // #region funções auxiliares para montar a apresentação de valores
        getFormaPagtoLiquidacao(string) {
            switch (string.substr(0, 3)) {
                case 'EPB': return 'Boleto'
                case 'EPP': return 'PIX'
                case 'EPC': return 'Cartão'
                default: return 'Boleto'
            }
        },
        getStatusHistoricoTed(ds_erro, cd_ted_arquivo_status, nm_ted_status) {
            switch (ds_erro) {
                case 'HA':
                    return 'Em processamento';
                case 'BW':
                    return '2 - Processado';
                default:
                    return cd_ted_arquivo_status + ' - ' + nm_ted_status;
            }
        },
        formatDataHoraToData(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora.split(' ')[0];
        },
        formatDataHora(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora;
        },
        formatData(string){
            return string ? string.split('-').reverse().join('/') : '';
        },
        formatDocumento(string) {
            if (string == null) {
                return '';
            } else {
                let v = string;
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                            .replace(/\.(\d{3})(\d)/, ".$1/$2")
                            .replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
        },
        formatCep(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{3})\d+?$/, '$1');
        },
        formatPhone(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{2})(\d)/, '($1) $2')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{4})\d+?$/, '$1');
        },
        formatRg(string){
            if (string == null) return '';
            else return string.replace(/\D/g,"")
                            .replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/,"$1.$2.$3-$4");
        },
        // #endregion
        // #region downloads -- detalhe do pedido
        //#endregion
    },
    data(){
        return{
            loading:false,
            error:false,
            resposta: 's',
            currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
            historicoTedDados:{},
            historicoBoletoDados:[],
            hasHistoricoTed:false,
            hasHistoricoBoleto:false,
            modalCancelamentoOk:false,
            statusGerarLote: [1, 13, 15],
            carregando: false,
            token:'',
            historicoTed:{},
            historicoBoleto:[],
            detalheCancelamento:[],
        }
    },
    computed:{
        nrPedido(){
            if(this.nrPedidoCancelamento !== undefined && this.nrPedidoCancelamento !== null) return this.nrPedidoCancelamento.toLocaleString();
            else return '';
        },
        pedido(){
            if(this.cancelamentoDados !== undefined && this.cancelamentoDados !== null){
                let pedidoDados     = this.cancelamentoDados;                
                let pedido          = {
                    data_pedido: this.formatDataHoraToData(pedidoDados.data_pedido),
                    vl_orcamento: pedidoDados.vl_orcamento ? this.currencyFormatter.format(pedidoDados.vl_orcamento) : '',
                    cd_pedido: pedidoDados.cd_pedido,
                    status_pedido: pedidoDados.status_pedido,
                    nm_chave_verificacao: pedidoDados.nm_chave_verificacao,
                };
                return pedido;
            }
            else return {}
        },
        cancelamento(){
            if(this.cancelamentoDados !== undefined && this.cancelamentoDados !== null){
                let pedidoCancelamentoDados     = this.cancelamentoDados;                
                let cancelamento                = {
                    documento_devedor: this.formatDocumento(pedidoCancelamentoDados.documento_devedor),
                    dt_emissao_titulo: this.formatData(pedidoCancelamentoDados.dt_emissao_titulo),
                    dt_venc_titulo: this.formatData(pedidoCancelamentoDados.dt_venc_titulo),
                    dt_protocolo: this.formatData(pedidoCancelamentoDados.dt_protocolo),
                    dt_ocorrencia: this.formatData(pedidoCancelamentoDados.dt_ocorrencia),
                    data_pedido: this.formatDataHoraToData(pedidoCancelamentoDados.data_pedido),
                    vl_custas_emol:  this.currencyFormatter.format(parseFloat(pedidoCancelamentoDados.vl_custas_emol)+parseFloat(pedidoCancelamentoDados.vl_repasse_ineo)),
                    vl_titulo:  pedidoCancelamentoDados.vl_titulo ? this.currencyFormatter.format(pedidoCancelamentoDados.vl_titulo):'',
                    vl_protesto:  pedidoCancelamentoDados.vl_protesto ? this.currencyFormatter.format(pedidoCancelamentoDados.vl_protesto):'',
                    cd_anuencia: pedidoCancelamentoDados.cd_anuencia,
                    status_anuencia: pedidoCancelamentoDados.status_anuencia,
                    nm_devedor: pedidoCancelamentoDados.nm_devedor,
                    nr_titulo: pedidoCancelamentoDados.nr_titulo,
                    nr_protocolo_titulo: pedidoCancelamentoDados.nr_protocolo_titulo,
                };
                return cancelamento;
            }
            else return {}
        },
        cartorio(){
            if(this.cancelamentoDados !== undefined && this.cancelamentoDados !== null){
                let cartorioDados   = this.cancelamentoDados;                
                let cartorio        = {
                    documento_cartorio: this.formatDocumento(cartorioDados.documento_cartorio),
                    cep_cartorio: this.formatCep(cartorioDados.cep_cartorio),
                    telefone_cartorio: this.formatPhone(cartorioDados.telefone_cartorio),
                    nome_cartorio: cartorioDados.nome_cartorio,
                    email_cartorio: cartorioDados.email_cartorio,
                    endereco_cartorio: cartorioDados.endereco_cartorio,
                    nr_endereco_cartorio: cartorioDados.nr_endereco_cartorio,
                    complemento_cartorio: cartorioDados.complemento_cartorio,
                    bairro_cartorio: cartorioDados.bairro_cartorio,
                    cidade_cartorio: cartorioDados.cidade_cartorio,
                    uf_cartorio: cartorioDados.uf_cartorio,
                };
                return cartorio;
            }
            else return {}
        },
        solicitante(){
            if(this.cancelamentoDados !== undefined && this.cancelamentoDados !== null){
                let solicitanteDados    = this.cancelamentoDados;                
                let solicitante         = {
                    documento_solicitante: this.formatDocumento(solicitanteDados.documento_solicitante),
                    telefone_solicitante: this.formatPhone(solicitanteDados.telefone_solicitante),
                    celular_solicitante: this.formatPhone(solicitanteDados.celular_solicitante),
                    nm_solicitante: solicitanteDados.nm_solicitante,
                    nm_email_solicitante: solicitanteDados.nm_email_solicitante,
                    endereco_solicitante: solicitanteDados.endereco_solicitante,
                    nr_endereco_solicitante: solicitanteDados.nr_endereco_solicitante,
                    complemento_solicitante: solicitanteDados.complemento_solicitante,
                    bairro_solicitante: solicitanteDados.bairro_solicitante,
                    cidade_solicitante: solicitanteDados.cidade_solicitante,
                    uf_solicitante: solicitanteDados.uf_solicitante,
                };
                return solicitante;
            }
            else return {}
        },
        anuencia(){
            if(this.detalheCancelamento !== undefined && this.detalheCancelamento !== null){
                let dados = this.detalheCancelamento.anuencia;
                if(dados !== undefined && dados !== null){
                    return {
                        dt_cadastro: this.formatDataHoraToData(dados.dt_cadastro),
                        vl_custas: this.currencyFormatter.format(dados.vl_custas),
                        cd_anuencia_titulo: dados.cd_anuencia_titulo ,
                        cd_titulo: dados.cd_titulo,
                        ds_anuencia_status: dados.ds_anuencia_status,
                        
                    };
                }
                else return [];
            }
            else return [];
        },
        certidao(){
            if(this.detalheCancelamento !== undefined && this.detalheCancelamento !== null){
                let dados = this.detalheCancelamento.certidao;
                if(dados !== undefined && dados !== null){
                    return {
                        id: dados.id,
                        dt_vencimento: dados.dt_vencimento,
                        data_pedido: dados.data_pedido,
                        motivo_solicitacao: dados.motivo_solicitacao,
                        cd_cliente: dados.cd_cliente,
                        cd_status: dados.cd_status,
                        documento: dados.documento,
                        pesquisado: dados.pesquisado,     
                        nm_nr_rg_certidao: dados.nm_nr_rg_certidao,
                        nr_cep_pesquisado: dados.nr_cep_pesquisado,
                        nm_endereco_pesquisado: dados.nm_endereco_pesquisado,
                        nm_bairro_pesquisado: dados.nm_bairro_pesquisado,
                        nm_cidade_pesquisado: dados.nm_cidade_pesquisado,
                        nm_uf_pesquisado: dados.nm_uf_pesquisado,
                        nm_email_pesquisado: dados.nm_email_pesquisado,
                        valor_cotacao: dados.valor_cotacao,
                        nm_chave_verificacao: dados.nm_chave_verificacao,
                        ic_entregue: dados.ic_entregue,
                        valor_cotacao_original: dados.valor_cotacao_original,
                        cd_ted_arquivo_antigo: dados.cd_ted_arquivo_antigo,
                        cd_ted_arquivo: dados.cd_ted_arquivo,
                        cd_ted_status: dados.cd_ted_status,
                        dtCadastro: dados.dtCadastro,
                        status: dados.status,
                        cd_pedido_cartorio: dados.cd_pedido_cartorio,
                        nm_chave: dados.nm_chave,
                        cd_titulo_devedor: dados.cd_titulo_devedor,
                        cd_produto: dados.cd_produto,
                        ultima_alteracao: dados.ultima_alteracao,      
                    };
                }
                else return [];
            }
            else return [];
        },
        titulo(){
            if(this.detalheCancelamento !== undefined && this.detalheCancelamento !== null){
                let dados = this.detalheCancelamento.titulo;
                if(dados !== undefined && dados !== null){
                    return {
                        nm_nr_documento_devedor: this.formatDocumento(dados.nm_nr_documento_devedor),
                        vl_titulo: this.currencyFormatter.format(dados.vl_titulo),
                        vl_protesto: this.currencyFormatter.format(dados.vl_protesto),
                        nm_nr_titulo: dados.nm_nr_titulo,
                        nm_nr_protocolo: dados.nm_nr_protocolo,
                        nm_devedor: dados.nm_devedor,
                        dt_emissaof: dados.dt_emissaof,
                        dt_vencimentof: dados.dt_vencimentof,
                        dt_protocolof: dados.dt_protocolof,
                        dt_ocorrenciaf: dados.dt_ocorrenciaf,
                    };
                }
                else return [];
            }
            else return [];
        },
    },
    mounted(){
    },
    watch:{
        nrPedidoCancelamento(val){
            if(val !== undefined && val !== '' && val !== null)
                this.modalCancelamentoOk = true;
            else
                this.modalCancelamentoOk = false;
        },
        modalCancelamentoOk(val){
            if(val){
                this.getCancelamentoDetalhe();
            }
        },
    }
}
</script>
<style scoped>

.modal-card{
    display: flex;
    flex-flow: column;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin-bottom: 30px;
    padding: 0 10px;
}
.modal-card-header{
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: .75rem 1.25rem;
}
h5 {
    font: normal normal 200 25px/25px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    margin: 0px;
}
h3 {
    font: normal normal 200 20px/18px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    color:var(--secondary-color) !important;
    margin: 0px;
}
span{
    margin-bottom: 18px;
    font: normal normal 200 16px/17px 'Kanit', sans-serif;
    letter-spacing: -1%;
}
.modal-card-body{
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-left{max-width: 370px;}
.card-column-left .modal-card-body{gap: 0;}
.card-column-right{max-width: calc(100% - 370px)}
.card-column-left .modal-card-body span{
    flex: 1 1 100%;
    max-width: 100%;
}
.card-column-right .modal-card-body .row-body{
    flex: 1 1 95%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-right .modal-card-body .row-body span{
    flex: 1 1 32%;
    max-width: 32%;
}
.card-column-right .modal-card-body > span{
    flex: 1 1 49%;
    max-width: 49%;
}
.btn.btn-success{
    width: 160px;
    height: 44px;
    background: #1ACEB5 0% 0% no-repeat padding-box;
    font: normal normal bold 15px/15px 'Kanit', sans-serif;
    border-radius: 5px;
    opacity: 1;
    border: none;
    outline: none;
}
.btn.btn-success:disabled{
    background:#1aceb55c 0% 0% no-repeat padding-box
}
.btn.btn-success:active,
.btn.btn-success:focus{
    background: #1ACEB5 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: none;
    outline: none;
}
hr{width: 100%;margin-bottom: 1rem;}


@media (max-width:1199px) {
    
    .card-column-left{max-width: unset;}
    .card-column-right{max-width: unset;}
    .card-column-right .modal-card-body > span{flex: 1 1 100%;max-width: 100%;}
    .card-column-right .modal-card-body .row-body span{flex: 1 1 100%;max-width: 100%;}
    .btn.download-ted{width: 100%;}
}
</style>